import {Link} from "@inertiajs/react";
import {Button} from "@/components/ui/button.tsx";
import {ArrowLeft} from "lucide-react";
import Form from "@/pages/communities/form.tsx";
import {CommunityType} from "@/pages/communities/types.ts";

interface NewProps {
    community: CommunityType
}

const New = ({ community }: NewProps) => {
    return (
        <div className="flex flex-col gap-6 p-8">
            {/* Header */}
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <Link href="/communities">
                        <Button variant="outline" size="icon">
                            <ArrowLeft className="h-4 w-4" />
                        </Button>
                    </Link>
                    <div>
                        <h1 className="text-3xl font-bold text-foreground">Ajouter une commune</h1>
                        <p className="text-sm text-muted-foreground">Ajouter une nouvelle commune dans le système</p>
                    </div>
                </div>



            </div>

            <Form
                community={community}
                method="post"
                action="/communities"
                submitText="Créer une communauté"
            />

        </div>
    );
};

export default New;
